import "./earn-reward-success.scss";

import { useUserIdentityContext } from "@core/services/user-identity.context";
import AnimatedCounter from "@core/ui/animated-counter/animated-counter";
import CustomerLevel from "@core/ui/customer-level/customer-level";
import {
  DeleteUserLevelModel,
  GetUserLevelModel,
} from "@factory/model/query-model-quota-system";
import { MutateResponseRegistrationModel } from "@factory/model/query-model-registration";
import {
  GetResponseRewardModel,
  RewardBalance,
} from "@factory/model/query-model-reward";
import { useQyGetGoogleCloudAssetPreview } from "@factory/query/google-cloud-storage.query";
import { useQyGetUserLevel } from "@factory/query/registration.query";
import { useQyGetRewardBalance } from "@factory/query/reward.query";
import useScreenSize from "@shared/utility/screen-size";
import { isNil } from "lodash-es";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Divider } from "primereact/divider";
import { useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import { appFeature } from "../../../app.feature";

export interface EarnRewardSuccessProps { }

export function EarnRewardSuccess() {
  const { isMobileMode } = useScreenSize();
  const { mutate: viewAsset } = useQyGetGoogleCloudAssetPreview();
  const navigate = useNavigate();
  const { getUserRole, getClientFeatures } = useUserIdentityContext();
  const { tenant } = getUserRole();
  const { cardAlias } = useParams();
  const [avatar, setAvatar] = useState<string>("");
  const [searchParam] = useSearchParams();
  const points = parseInt(searchParam.get("points") ?? "0", 10);
  const stamp = parseInt(searchParam.get("stamp") ?? "0", 10);
  const { pointsText, stampsText } = appFeature.config.label;
  const [userLevelData, setUserLevelData] = useState<
    GetUserLevelModel | undefined
  >();
  const clientFeatures = getClientFeatures();
  const [balanceData, setBalanceData] = useState<RewardBalance>();

  const handleUserLevelOnSuccess = (
    response: MutateResponseRegistrationModel,
  ) => {
    const data = response?.data as GetUserLevelModel;
    if (data === null || data === undefined) {
      return;
    }
    setUserLevelData(data);
  };
  const { mutate: getUserLevel } = useQyGetUserLevel(handleUserLevelOnSuccess);

  const handleBalanceApiSuccess = (response: GetResponseRewardModel) => {
    const data = response as RewardBalance;
    if (data?.level_avatar) {
      viewAsset(data?.level_avatar, {
        onSuccess(data) {
          const assetDisplay = URL.createObjectURL(data);
          setAvatar(assetDisplay);
        },
      });
    }
    setBalanceData(data)
    // if (clientFeatures?.featureQuota) {
    //   getUserLevel({ code: data?.user_code || "" } as DeleteUserLevelModel);
    // }
  };
  useQyGetRewardBalance(
    cardAlias ?? "",
    tenant, 
    true, 
    handleBalanceApiSuccess,
  );

  // LOCAL RENDERS
  const footerContent = (
    <div>
      <Button
        className="block w-full mt-2"
        label="Close"
        severity="secondary"
        outlined
        onClick={() => navigate("/business/campaign")}
      />
    </div>
  );

  return (
    <div id="EarnRewardSuccess" className="earn-reward-success">
      <Dialog
        header="Earn Success"
        visible={true}
        style={{ width: "50vw" }}
        onHide={() => {
          navigate("/business/campaign");
        }}
        closeOnEscape={true}
        footer={footerContent}
        closable={false}
        maximized={isMobileMode}
      >
        <div className="m-0">
          {balanceData ? (
            <CustomerLevel balance={balanceData} avatar={avatar} />
          ) : null}

          {balanceData ? (
            <div className="text-center">
              <h3>Congratulations!</h3>
              <span className="text-green-500 text-4xl font-bold block">
                {balanceData.first_name} {balanceData.last_name}
              </span>
              <h5>You earned</h5>
            </div>
          ) : null}

          <div className="flex justify-center gap-4 mt-6">
            {points ? (
              <AnimatedCounter
                from={0}
                to={points}
                duration={1}
                delay={1}
                label={pointsText}
              />
            ) : null}
            <Divider layout="vertical" />
            {stamp ? (
              <AnimatedCounter
                from={0}
                to={stamp}
                duration={1}
                delay={1}
                label={stampsText}
              />
            ) : null}
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default EarnRewardSuccess;
